import React from 'react';
import './scss/export-footer.scss';
import moment from 'moment';
import { printDate } from 'util/dateUtils';
const getFormattedDate = () => {
  const today = moment();
  const year = new Date().getFullYear();
  let formattedDate = printDate(today.toLocaleString());

  return { year, formattedDate };
};

interface ExportFooterProps {
  className?: any;
  email: any;
  page?: any;
  totalPages: any;
}
// Update: Footer no longer being used!
// Footer is dynamically generated via Puppeteer.
const ExportFooter = ({ className, email, page, totalPages }: ExportFooterProps) => {
  const { year, formattedDate } = getFormattedDate();
  return (
    <footer className={className ? `${className} pdf-layout__footer` : 'pdf-layout__footer'}>
      <div className="pdf-layout__footer-creator">
        <p>Created by: {`${email} (${formattedDate})`}</p>
      </div>
      <div className="pdf-layout__footer-pagination">
        Page <strong>{page}</strong> of <strong>{totalPages}</strong>
      </div>
      <div className="pdf-layout__footer-copyright">
        <p>Copyright &copy; {year} Thomas Publishing Company</p>
      </div>
    </footer>
  );
};

ExportFooter.defaultProps = {
  email: 'email@thomasnet.com'
  // page: "1",
  // totalPages: "4",
};

export default ExportFooter;
